function hasScore(value) {
    return value != null && Number.isFinite(Number(value));
}

export function kpiInsightBand(kind, score) {
    if (!hasScore(score)) return "none";
    const n = Number(score);
    if (kind === "nps") {
        if (n < 0) return "negative";
        if (n < 30) return "low";
        if (n < 50) return "fair";
        if (n < 70) return "good";
        return "excellent";
    }
    if (kind === "loyalty") {
        if (n < 25) return "weak";
        if (n < 45) return "fair";
        if (n < 65) return "good";
        return "strong";
    }
    if (n < 50) return "weak";
    if (n < 65) return "fair";
    if (n < 80) return "good";
    return "strong";
}

export function insightKindForMetric(metricKey) {
    if (metricKey === "nps" || metricKey === "enps") return "nps";
    if (metricKey === "loyalty") return "loyalty";
    return "percent";
}

export function kpiInsightCopy(t, metricKey, score, vars = {}) {
    const kind = insightKindForMetric(metricKey);
    const band = kpiInsightBand(kind, score);
    return {
        how: t(`reports.kpi.${metricKey}.how`),
        analysis: t(`reports.kpi.${metricKey}.${band}`, vars),
    };
}
